import { ModeSettingEnum } from '@colonist/game-base-types';
import { PlayerColor, VictoryPointType } from '@colonist/game-states';
import IconChit from '@static/images/icon_chit.svg';
import IconMetropolisScience from '@static/images/metropolis_science.svg';
import IconMetropolisTrade from '@static/images/metropolis_trade.svg';
import IconMetropolisPolitics from '@static/images/metropolis_politics.svg';
import CardVP from '@static/images/card_vp.svg';
import IconLargestArmyHighlight from '@static/images/icon_largest_army_highlight.svg';
import IconLongestRoadHighlight from '@static/images/icon_longest_road_highlight.svg';
import IconDefender from '@static/images/icon_defender.svg';
import CardProgressSciencePrinter from '@static/images/card_progress_science_printer.svg';
import CardProgressPoliticsConstitution from '@static/images/card_progress_politics_constitution.svg';
import { SETTLEMENT_IMAGE_PATH, CITY_IMAGE_PATH, MERCHANT_IMAGE_PATH } from '../../../../utils/gamePieces.ts';
const settlementVPInformation = {
    type: VictoryPointType.Settlement,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.Settlement.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.Settlement.description'
    }
};
const cityVPInformation = {
    type: VictoryPointType.City,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.City.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.City.description'
    }
};
const developmentCardVPInformation = {
    type: VictoryPointType.DevelopmentCardVictoryPoint,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.DevelopmentCardVictoryPoint.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.DevelopmentCardVictoryPoint.description'
    }
};
const largestArmyVPInformation = {
    type: VictoryPointType.LargestArmy,
    vpAmount: 2,
    title: {
        key: 'strings:game.VictoryPointTypes.LargestArmy.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.LargestArmy.description'
    }
};
const longestRoadVPInformation = {
    type: VictoryPointType.LongestRoad,
    vpAmount: 2,
    title: {
        key: 'strings:game.VictoryPointTypes.LongestRoad.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.LongestRoad.description'
    }
};
const chitsVPInformation = {
    type: VictoryPointType.Chits,
    vpAmount: 2,
    title: {
        key: 'strings:game.VictoryPointTypes.Chits.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.Chits.description'
    },
    secondaryIcon: IconChit
};
const scienceMetropolisVPInformation = {
    type: VictoryPointType.Metropolis,
    vpAmount: 2,
    title: {
        key: 'strings:game.VictoryPointTypes.Metropolis.title',
        options: {
            context: 'Science'
        }
    },
    description: {
        key: 'strings:game.VictoryPointTypes.Metropolis.description',
        options: {
            context: 'Science'
        }
    },
    secondaryIcon: IconMetropolisScience
};
const tradeMetropolisVPInformation = {
    type: VictoryPointType.Metropolis,
    vpAmount: 2,
    title: {
        key: 'strings:game.VictoryPointTypes.Metropolis.title',
        options: {
            context: 'Trade'
        }
    },
    description: {
        key: 'strings:game.VictoryPointTypes.Metropolis.description',
        options: {
            context: 'Trade'
        }
    },
    secondaryIcon: IconMetropolisTrade
};
const politicsMetropolisVPInformation = {
    type: VictoryPointType.Metropolis,
    vpAmount: 2,
    title: {
        key: 'strings:game.VictoryPointTypes.Metropolis.title',
        options: {
            context: 'Politics'
        }
    },
    description: {
        key: 'strings:game.VictoryPointTypes.Metropolis.description',
        options: {
            context: 'Politics'
        }
    },
    secondaryIcon: IconMetropolisPolitics
};
const defenderOfColonistVPInformation = {
    type: VictoryPointType.DefenderOfColonist,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.DefenderOfColonist.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.DefenderOfColonist.description'
    }
};
const printerProgressCardVPInformation = {
    type: VictoryPointType.ProgressCardVictoryPoint,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.ProgressCardVictoryPoint.title',
        options: {
            context: 'Printer'
        }
    },
    description: {
        key: 'strings:game.VictoryPointTypes.ProgressCardVictoryPoint.description',
        options: {
            context: 'Printer'
        }
    }
};
const constitutionProgressCardVPInformation = {
    type: VictoryPointType.ProgressCardVictoryPoint,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.ProgressCardVictoryPoint.title',
        options: {
            context: 'Constitution'
        }
    },
    description: {
        key: 'strings:game.VictoryPointTypes.ProgressCardVictoryPoint.description',
        options: {
            context: 'Constitution'
        }
    }
};
const merchantVPInformation = {
    type: VictoryPointType.Merchant,
    vpAmount: 1,
    title: {
        key: 'strings:game.VictoryPointTypes.Merchant.title'
    },
    description: {
        key: 'strings:game.VictoryPointTypes.Merchant.description'
    }
};
const baseGameVPInformation = [
    settlementVPInformation,
    cityVPInformation,
    longestRoadVPInformation
];
const citiesAndKnightsVPInformation = [
    merchantVPInformation,
    defenderOfColonistVPInformation,
    printerProgressCardVPInformation,
    constitutionProgressCardVPInformation,
    scienceMetropolisVPInformation,
    tradeMetropolisVPInformation,
    politicsMetropolisVPInformation
];
export function getVPInformation(gameMode, isMechanicIslandExplorationActive) {
    const baseGameVPs = [
        ...baseGameVPInformation,
        largestArmyVPInformation,
        developmentCardVPInformation
    ];
    const sortedBaseGameVPs = baseGameVPs.sort((a, b)=>a.vpAmount - b.vpAmount);
    const seafarersVPs = [
        ...baseGameVPInformation,
        largestArmyVPInformation,
        developmentCardVPInformation
    ];
    if (isMechanicIslandExplorationActive) seafarersVPs.push(chitsVPInformation);
    const sortedSeafarersVPs = seafarersVPs.sort((a, b)=>a.vpAmount - b.vpAmount);
    const citiesAndKnightsVPs = [
        ...baseGameVPInformation,
        ...citiesAndKnightsVPInformation
    ];
    const sortedCitiesAndKnightsVPs = citiesAndKnightsVPs.sort((a, b)=>a.vpAmount - b.vpAmount);
    const citiesAndKnightsSeafarersVPs = [
        ...baseGameVPInformation,
        ...citiesAndKnightsVPInformation
    ];
    if (isMechanicIslandExplorationActive) citiesAndKnightsSeafarersVPs.push(chitsVPInformation);
    const sortedCitiesAndKnightsSeafarersVPs = citiesAndKnightsSeafarersVPs.sort((a, b)=>a.vpAmount - b.vpAmount);
    switch(gameMode){
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return sortedSeafarersVPs;
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return sortedCitiesAndKnightsVPs;
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return sortedCitiesAndKnightsSeafarersVPs;
        default:
            return sortedBaseGameVPs;
    }
}
export function getVPTypeIconPath(vpInfo, color) {
    const isPlayerSpectator = color === 0;
    const resolvedColor = isPlayerSpectator ? PlayerColor.Blue : color;
    switch(vpInfo.type){
        case VictoryPointType.Settlement:
        case VictoryPointType.Chits:
            return SETTLEMENT_IMAGE_PATH[resolvedColor];
        case VictoryPointType.City:
        case VictoryPointType.Metropolis:
            return CITY_IMAGE_PATH[resolvedColor];
        case VictoryPointType.DevelopmentCardVictoryPoint:
            return CardVP;
        case VictoryPointType.LargestArmy:
            return IconLargestArmyHighlight;
        case VictoryPointType.LongestRoad:
            return IconLongestRoadHighlight;
        case VictoryPointType.DefenderOfColonist:
            return IconDefender;
        case VictoryPointType.Merchant:
            return MERCHANT_IMAGE_PATH[resolvedColor];
        case VictoryPointType.ProgressCardVictoryPoint:
            const isPrinter = vpInfo.title == printerProgressCardVPInformation.title;
            return isPrinter ? CardProgressSciencePrinter : CardProgressPoliticsConstitution;
        default:
            return SETTLEMENT_IMAGE_PATH[resolvedColor];
    }
}
